var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27081_173471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_27081_173471)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_27081_173471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10C14.25 11.2427 13.2427 12.25 12 12.25C10.7573 12.25 9.75 11.2427 9.75 10C9.75 8.75735 10.7573 7.75 12 7.75C13.2427 7.75 14.25 8.75735 14.25 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.5C18.5 12.4665 17.7165 13.25 16.75 13.25C15.7835 13.25 15 12.4665 15 11.5C15 10.5335 15.7835 9.75 16.75 9.75C17.7165 9.75 18.5 10.5335 18.5 11.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2893 13.1387C17.8865 13.5174 17.3449 13.7502 16.7496 13.7502C16.5961 13.7502 16.4465 13.7346 16.3018 13.7052C16.7449 14.4512 16.9996 15.3215 16.9996 16.2503H19.7496C19.8877 16.2503 19.9996 16.1384 19.9996 16.0003C19.9996 14.765 19.3068 13.6884 18.2893 13.1387V13.1387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5C9 12.4665 8.21651 13.25 7.25 13.25C6.28349 13.25 5.5 12.4665 5.5 11.5C5.5 10.5335 6.28349 9.75 7.25 9.75C8.21651 9.75 9 10.5335 9 11.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 13.7502C6.65469 13.7502 6.11312 13.5174 5.71027 13.1387C4.69277 13.6884 4 14.7649 4 16.0003C4 16.1384 4.11187 16.2503 4.25 16.2503H7C7 15.3215 7.255 14.4512 7.69781 13.7052C7.55312 13.7346 7.40312 13.7502 7.25 13.7502V13.7502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7621 12.1094C13.2846 12.5091 12.6699 12.75 12 12.75C11.3301 12.75 10.7153 12.5091 10.2379 12.1094C8.62973 12.7963 7.5 14.3934 7.5 16.25H16.5C16.5 14.3938 15.37 12.7966 13.7621 12.1094Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27081_173471",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF598"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27081_173471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_27081_173471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.24191b9667b828f58f210e1c60a1b5ef.svg";
export { ForwardRef as ReactComponent };